import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e37afbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-upload-container" }
const _hoisted_2 = { class: "c-upload-select" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-upload-txt" }, "上传图片", -1))
const _hoisted_4 = {
  key: 0,
  class: "c-upload-preview"
}
const _hoisted_5 = ["src"]

import { computed, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import Message from '../cMessage'
interface CUploadProps {
  label?: string,
  value?: string,
  url?: string
}

const __default__ = {
  name: 'CUpload'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: {},
    value: {},
    url: {}
  },
  emits: ['update:url'],
  setup(__props: any, { emit: __emit }) {

const store = useStore()
const props = __props

const emit = __emit
const state = reactive({
  file: null,
  fileUrl: '',
  imgUrl: ''
})
const imgUrl = computed(() => {
  return process.env.VUE_APP_BASE_API + props.url
})

const fileUploader = ref<HTMLInputElement | null>(null)
const onUploadClick = () => {
  // onFileChange()
  fileUploader.value?.click()
}
const onDragEnter = (e: DragEvent) => {
  e.preventDefault()
}
const onDragOver = (e: DragEvent) => {
  e.preventDefault();
}
const onDrop = (e: DragEvent) => {
  e.preventDefault()
  // console.log(e.dataTransfer?.files)
  let file = e.dataTransfer?.files[0] as File
  handleFile(file)
}
// 将图片文件转成BASE64格式
const html5Reader = (file: File) => {
  if (file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      // console.log(e.target?.result)
      state.fileUrl = e.target?.result as string
      emit('update:url', state.fileUrl)
    }
    reader.readAsDataURL(file)
  }
}
//上传图片
const uploadImage = (file: File) => {
  let formdata = new FormData()
  formdata.append('image', file)
  store.dispatch('baseData/uploadImage', formdata).then(res => {
    // console.log(res, 'res')
    let url = new URL(res)
    // console.log(new URL(res))
    if (res) {
      emit('update:url', url.pathname)
    }
  }).catch(err => {
    Message.warn(err.message)
  })
}
const handleFile = (file: File) => {
  // console.log(file)
  uploadImage(file)
  // html5Reader(file)
}
const onFileChange = (e: Event) => {
  let file = (e.target as HTMLInputElement).files![0];
  handleFile(file)
} 

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "c-upload-box",
      onClick: onUploadClick,
      onDragenter: onDragEnter,
      onDragover: onDragOver,
      onDrop: onDrop
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          ref_key: "fileUploader",
          ref: fileUploader,
          type: "file",
          accept: "image/*",
          onChangeCapture: onFileChange,
          style: {"display":"none"}
        }, null, 544),
        _createVNode(_component_svg_icon, {
          class: "c-upload-icon",
          icon: "add"
        }),
        _hoisted_3
      ]),
      (_ctx.url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              src: imgUrl.value,
              alt: ""
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}
}

})